import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import React from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';

type EditableFormProps = {
  title: string;
  children: (args: { editing: boolean }) => React.ReactNode;
};

export const EditableFormCard = ({ title, children }: EditableFormProps) => {
  const [editing, setEditing] = React.useState<boolean>(false);

  const toggleEditing = () => {
    setEditing(!editing);
  };

  return (
    <Card className="border bg-white">
      <Card.Body className="px-3">
        <OverlayTrigger placement="top" overlay={<Tooltip>{t('common.edit')}</Tooltip>}>
          <button className="h5 p-0 fw-bold border-0 bg-transparent" onClick={toggleEditing}>
            {title} <FontAwesomeIcon className="ms-1" icon={faEdit} />
          </button>
        </OverlayTrigger>
        {children({ editing })}
      </Card.Body>
    </Card>
  );
};
